import React, { useCallback, useMemo } from 'react';
import { Button, Divider, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EMAIL_REGEX } from '../../helpers';
import { selectMobileDeviceState } from '../../modules/public/globalSettings';
import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../../firebase';
import googleIcon from '../../assets/images/googleIcon.svg';
import { Switch } from 'antd';
export const SignInComponent2 = ({ isLoading, onForgotPassword, onSignUp, onSignIn, handleSignInGoogle }: any) => {
    const [form] = Form.useForm();
    const isMobileDevice = useSelector(selectMobileDeviceState);
    const history = useHistory();

    const handleFinish = useCallback(
        (values) => {
            onSignIn(values);
        },
        [onSignIn],
    );
    const onChange = (checked: boolean) => {
        console.log(`switch to ${checked}`);
    };
    const handleLoginWithGoogle = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            const userInfo = {
                email: result.user.email,
                fullName: result.user.displayName,
                accessToken: (result.user as any).accessToken,
            };
            handleSignInGoogle(userInfo.email, userInfo.fullName, userInfo.accessToken);
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const renderForgotButton = useMemo(
        () => (
            <div className="cr-sign-in-form__bottom-section">
                <div
                    className="cr-sign-in-form__bottom-section-password"
                    onClick={() => onForgotPassword(form.getFieldValue('email'))}>
                    {'Forgot password?'}
                </div>
            </div>
        ),
        [onForgotPassword, form],
    );

    return (
        <div className="cr-sign-in-form">
            <div className="cr-sign-in-form__options-group">
                <div className="cr-sign-in-form__option">
                    <div className="cr-sign-in-form__option-inner __selected">Sign In</div>
                </div>
                <div className="cr-sign-in-form__option">
                    <div className="cr-sign-in-form__option-inner cr-sign-in-form__tab-signup" onClick={onSignUp}>
                        Sign Up
                    </div>
                </div>
            </div>
            <Form
                form={form}
                className="cr-sign-in-form__form-content"
                name="signin"
                onFinish={handleFinish}
                layout="vertical"
                autoComplete="off">
                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: 'Please input your email!' },
                        { pattern: EMAIL_REGEX, message: 'Invalid email!' },
                    ]}>
                    <Input
                        type="email"
                        size="large"
                        placeholder="Enter your email"
                        autoFocus={!isMobileDevice}
                        className="cr-sign-in-form__form-content___input"
                    />
                </Form.Item>

                <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
                    <Input.Password
                        size="large"
                        placeholder="Enter your password"
                        className="cr-sign-in-form__form-content___input"
                    />
                </Form.Item>

                {!isMobileDevice && renderForgotButton}

                <Form.Item>
                    <Button
                        className="cr-sign-in-form__form-content___button-submit-sign-in"
                        block
                        type="primary"
                        htmlType="submit"
                        // disabled={(isLoading || )isButtonDisabled()}
                        size="small"
                        loading={isLoading}>
                        Log In
                    </Button>
                    <Divider className="cr-sign-in-form__form-content___divider">or log in with</Divider>
                    <div className="cr-sign-in-form__form-content___google-btn">
                        <Button
                            className="btn-submit-sign-up "
                            type="primary"
                            onClick={handleLoginWithGoogle}
                            block
                            icon={<img src={googleIcon} style={{ width: '45px' }} alt="Google Icon" />}
                        />
                    </div>
                </Form.Item>
            </Form>
        </div>
    );
};
